export default "__VITE_ASSET__BBiTUE_8__"